import focusLock from './focusLock';
import clamp from '../util/clamp';
import Vue from 'vue';

const blog = () => {
	const el = document.getElementById('post-archive');

	if (!el) {
		return;
	}

	const carouselArticles = Array.prototype.slice.call(el.querySelectorAll('[data-blog-id]'));
	const blogPostIds = carouselArticles.map(article => {
		return +article.dataset.blogId;
	})

	new Vue({
		el,

		data: {
			toggled: [],
			blogPostIds,
			carouselIndex: -1,
			listeners: [],
		},

		computed: {
			viewportTransformation() {
				return `translateX(-${ this.carouselIndex * 100 }%) translateX(-${ this.carouselIndex * 100 }vw)`;
			},

			canAdvance() {
				return this.carouselIndex < (this.blogPostIds.length - 1);
			},
		},

		methods: {
			keyboardListener({ key }) {
				if (key === 'Escape') {
					this.handleCarouselClose();
				} else if (key === 'ArrowRight') {
					this.handleNext();
				} else if (key === 'ArrowLeft') {
					this.handlePrevious();
				}
			},

			handleCardClick(id) {
				if (window.innerWidth > 768) {
					this.handleCarouselOpen(id);
				}
			},

			handleBlogToggle(e) {

				const currentIndex = this.toggled.indexOf(e.currentTarget);
				if (currentIndex !== -1) {
					this.toggled.splice(currentIndex, 1);
				} else {
					this.toggled.push(e.currentTarget);
				}

				const textContainer = e.currentTarget.closest('.expander-text').querySelector('[class*="dropdown-button__text"]');

				if (this.toggled.includes(e.currentTarget)) {
					textContainer.classList.add('dropdown-button__text--toggled');
					e.currentTarget.querySelector('.dropdown-button--up').style.display = '';
					e.currentTarget.querySelector('.dropdown-button--down').style.display = 'none';
				} else {
					textContainer.classList.remove('dropdown-button__text--toggled');
					e.currentTarget.querySelector('.dropdown-button--up').style.display = 'none';
					e.currentTarget.querySelector('.dropdown-button--down').style.display = '';
				}
			},

			handleCarouselOpen(id) {
				// stop scrolling on the body when the modal is open
				document.body.style.overflow = 'hidden';

				window.addEventListener('keydown', this.keyboardListener);

				this.carouselIndex = this.blogPostIds.indexOf(id);
			},

			handleCarouselClose() {
				// restart scrolling on the body when the carousel closes
				document.body.style.overflow = '';

				// remove event listeners added by focusLock
				window.removeEventListener('keydown', this.keyboardListener);
				this.listeners.forEach(listener => {
					document.querySelector('.carousel__viewport').removeEventListener('keydown', listener);
				});
				this.listeners = [];

				this.carouselIndex = -1;
			},

			handleViewportClick(e) {
				// prevent event from bubbling through to backing
				// so that the user can click on the carousel contents
				// and not dismiss the modal.
				e.stopImmediatePropagation();
			},

			handleNext() {
				this.carouselIndex = clamp(0, this.blogPostIds.length - 1, this.carouselIndex + 1);
			},

			handlePrevious() {
				this.carouselIndex = clamp(0, this.blogPostIds.length - 1, this.carouselIndex - 1);

			},

		},

		updated() {

			// add event listeners with focusLock and store them in an array
			// so that we can remove them later when the carousel closes.
			if (this.carouselIndex !== -1 && !this.listeners.length) {
				this.listeners = focusLock({
					elements: [document.querySelector('.carousel__viewport')],
					sizes: [0, Infinity],
					controlledBy: document.querySelector('.carousel__viewport'),
				});
			}

		},

	});

};

export default blog;


// WEBPACK FOOTER //
// ./scripts/modules/blog.js